@for (item of items; track item; let i = $index) {
  <ellf-checkbox
    [label]="item.description"
    [formControl]="getControl(i)"
  ></ellf-checkbox>
}
